import React from 'react';
import './CallToAction.css';

const CallToAction = () => {
  return (
    <section className="cta-section">
      <div className="container">
        <div className="cta-content">
          <h2 style={{ color: 'rgb(179, 139, 109)' }}>Start your journey to better health today</h2>
          <p className="cta-text">
            Aspen Quick Care provides fast, reliable urgent care services when you need them most. 
            Walk-ins welcome. Open 7 days a week with extended hours.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
